export default __webpack_public_path__ + "static/media/test-1920x1080.png.2887bc44.old";